import styled from 'styled-components';
import { default as DelCirBtn } from 'core/icons/DeleteCircleBtn';
import { getColor } from 'core/utils';

export const ShopBagItemContainer = styled.div`
	border-top: solid 0.5px ${getColor("alto")};
	padding: 12px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 -5px;
`;


export const ItemContainer = styled.div`
	display: flex;
	flex-basis: calc(100% - 100px);
	padding: 0 5px;
	margin: 0 -6px;
`;


export const ItemImageContainer = styled.div`
	flex: 0 0 105px;
	overflow: hidden;
	padding: 0 6px;
`;


export const ItemDescriptionContainer = styled.div`
	font-weight: 600;
	display: flex;
	flex-direction: column;
	padding: 0 6px;
`;


export const LinkStyle = styled.a`
	color: ${getColor("gray")};

	&:link, &:visited, &:hover, &:active {
		color: ${getColor("gray")};
		text-decoration: none;
	}
`;

export const ButtonWrapper = styled.div`
	padding: 0 5px;
	flex-basis: 100px;
	width: 100px;
`;

export const CheckoutButtonStyle = styled.a`
	height: 36px;
	width: 100%;
	border: 2px solid ${getColor("gray")};
	color: ${getColor("gray")};
	font-weight: 600;
	background: #fff;
	align-self: center;
	border-radius: 0;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background: ${getColor("gray")};
		color: #fff;
	}
`;

export const DeleteItemStyle = styled.div`
	display: flex;
	align-items: center;
	margin-top: 8px;
	font-size: 12px;
	cursor: pointer;
	color: #9b9b9b;
	letter-spacing: 0.2px;
`;

export const Name = styled.span`
	/* stylelint-disable property-no-vendor-prefix, value-no-vendor-prefix */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	/* stylelint-enable */

	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 19px;
	max-height: 38px;

	@media (max-width: 425px) {
		word-break: break-word;
	}
`;

export const DeleteCircle = styled(DelCirBtn)`
	display: block;
	margin-right: 2px;
	margin-bottom: 2px;
`;
